module.exports = __webpack_public_path__ + "img/bindStep.0be31f59.png";